import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as surveyConfiguration from '../../../../survey-configuration'
import type { Plugin } from '../plugin'

/**
 * Gets warnings when survey configuration is successfully updated.
 */
export const loadForCurrentEntityOnSurveyConfigurationChange =
  store.effects.create(
    (
      feature: Plugin['feature'],
      surveyConfigurationFeature: surveyConfiguration.Feature,
    ) =>
      surveyConfigurationFeature.actions.upsert.success
        .observe()
        .pipe(
          rxjs.map(() =>
            feature.actions.loadForCurrentEntity.request
              .from(
                '(effect) load for current entity on survey configuration change',
              )
              .create(),
          ),
        ),
  )
